export const EMPLOYEEREPORTS_ROUTEPATHS = {
  Reports_Employee_Index: "/reportstab/employees",
  ActiveEmployees_Reports:
    "/reportstab/employees/employees_activeemployees_reports",
  ActiveSPLCEmployees_Reports:
    "/reportstab/employees/employees_activesplcemployees_reports",
  ActiveEmployeesNoEmailAddress_Report:
    "/reportstab/employees/employees_no_emailaddress_reports",
  ActiveEmployeesAtClosedLocations_Report:
    "/reportstab/employees/employees_closedlocations_reports",
  ActiveEmployeesNoEmployeeId_Report:
    "/reportstab/employees/employees_noemployeeid_reports",
  EmployeesWithTerminatedSupervisors_Report:
    "/reportstab/employees/employees_withterminatedsupervisors_reports",
  ActiveTempReport_Report: "/reportstab/employees/employees_activetemp_reports",
  PendingTermination_Report:
    "/reportstab/employees/employees_pendingtermination_reports",
  AllTressEmployees_Report:
    "/reportstab/employees/employees_alltressemployees_reports",
  FranchiseeEmployees_Report:
    "/reportstab/employees/employees_franchiseeemployees_reports",
  FranchiseeOwners_Report:
    "/reportstab/employees/employees_franchiseeowners_reports",
  UltiproPeople_Report: "/reportstab/employees/employees_ultipropeople_reports",
};

export const EMPLOYEEREPORTS_PERMISSIONS = {
  permission_report_employees_view: "permission.report.employees.view",
  permission_report_employees_active_employee_view:
    "permission.report.employees.active.employee.view",
  permission_report_employees_active_splc_employee_view:
    "permission.report.employees.active.splc.employee.view",
  permission_report_employees_active_employee_no_emailaddress_view:
    "permission.report.employees.active.employee.no.emailaddress.view",
  permission_report_employees_active_employee_closed_location_view:
    "permission.report.employees.active.employee.closed.location.view",
  permission_report_employees_active_employee_no_employeeid_view:
    "permission.report.employees.active.employee.no.employeeid.view",
  permission_report_employees_with_terminated_supervisor_view:
    "permission.report.employees.with.terminated.supervisor.view",
  permission_report_employees_activetemp_view:
    "permission.report.employees.activetemp.view",
  permission_report_employees_pending_termination_view:
    "permission.report.employees.pending.termination.view",
  permission_report_employees_all_tressemployees_view:
    "permission.report.employees.all.tressemployees.view",
  permission_report_employees_franchisee_employees_view:
    "permission.report.employees.franchisee.employees.view",
  permission_report_employees_franchisee_owners_view:
    "permission.report.employees.franchisee.owners.view",
  permission_report_employees_ultipro_people_view:
    "permission.report.employees.ultipro.people.view",
};
